// New product card (snippets/product-card-sets-new.liquid): keep the discount pill
// in sync with the colour swatch. Loaded globally from layout/theme.liquid because
// the card renders on many templates (PLP, homepage, PDP sliders, search, landers).
(function () {
  const updateDiscountPill = (card, swatch) => {
    if (!card || !swatch || !swatch.hasAttribute('data-discount-pill-html')) return;

    const html = swatch.getAttribute('data-discount-pill-html');

    card.querySelectorAll('.xc-price-discount').forEach((el) => el.remove());
    if (!html) return;

    const template = document.createElement('template');
    template.innerHTML = html.trim();
    const pill = template.content.firstElementChild;
    if (!pill) return;

    const priceRow = card.querySelector('.xc-price-row');
    if (priceRow) {
      const desPill = pill.cloneNode(true);
      desPill.classList.remove('xc-price-discount--mob');
      desPill.classList.add('xc-price-discount--des');
      priceRow.appendChild(desPill);
    }

    const info = card.querySelector('.product-card__info');
    if (info) {
      const mobPill = pill.cloneNode(true);
      mobPill.classList.remove('xc-price-discount--des');
      mobPill.classList.add('xc-price-discount--mob');
      info.appendChild(mobPill);
    }
  };

  // Both swatch handlers call window.syncQuickBuyDrawerFromSwatch on every swatch
  // switch: applySwatchState (main-collection-sets.js) on the PLP, handleSwatchAction
  // (custom.js) everywhere else. So chain onto that hook. product-quick-buy.js
  // (re)assigns the hook at the end of body — so the wrapper must be installed at
  // DOMContentLoaded, which fires only after all defer scripts have executed.
  let installed = false;
  const install = () => {
    if (installed) return;
    installed = true;

    const original = window.syncQuickBuyDrawerFromSwatch;
    window.syncQuickBuyDrawerFromSwatch = function (card, swatch) {
      if (typeof original === 'function') original(card, swatch);
      updateDiscountPill(card, swatch);
    };
  };

  // Defer scripts run while readyState is already 'interactive', BEFORE
  // DOMContentLoaded — so waiting for the event is what guarantees we wrap
  // AFTER product-quick-buy.js has assigned the hook at the end of body.
  if (document.readyState === 'complete') {
    install();
  } else {
    document.addEventListener('DOMContentLoaded', install);
    window.addEventListener('load', install);
  }
})();
